import { render, staticRenderFns } from "./BasicTemplate.vue?vue&type=template&id=26b563bf&scoped=true"
import script from "./BasicTemplate.vue?vue&type=script&lang=js"
export * from "./BasicTemplate.vue?vue&type=script&lang=js"
import style0 from "./BasicTemplate.vue?vue&type=style&index=0&id=26b563bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b563bf",
  null
  
)

export default component.exports